export default __webpack_public_path__ + "static/media/financial_grey.338d036d.svg";